import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToDDMMYYYY, dayToHour } from "../../../utils/dateConvert";
import { rounding } from "../../../utils/math";
import moment from "moment-timezone";
import { downloadCSVFile } from "../../../api/apiClient";
import { NavLink } from "react-router-dom";
import ShowIButtonName from "../../commoncomponents/showIButtonName";

function HourlySummary(props) {
    const reports = props.reportDetails.dayTrips;
    let assetName = props.assetCustomerName;
    let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
    let asset_id = props.assetId;
    let iButtonName = props.reportDetails.iButtonName;
    let ibuttonId = props.reportDetails.ibuttonId;
    let serialno = props.reportDetails.serialno;

    const weekDayFinder = (dayProp) => {
        let dayNumber = moment(dayProp).day();
        switch (dayNumber) {
            case 1: return "Monday";
            case 2: return "Tuesday";
            case 3: return "Wednesday";
            case 4: return "Thursday";
            case 5: return "Friday";
            case 6: return "Saturday";
            case 0: return "Sunday";
            default: return null;
        }
    };
    const data = (
        <Table responsive striped>
            <thead>
                <tr className="nowwrapTH">
                    <th>Day</th>
                    <th>Date</th>
                    <th>Asset</th>
                    <th>
                        Duration &nbsp;
                        <i
                            class="fa fa-info-circle text-primary"
                            title="First Engine ON to Last Engine OFF"
                        ></i>
                    </th>
                    <th>
                        Duration Outside Depot&nbsp;
                        <i
                            class="fa fa-info-circle text-primary"
                            title="First Departure until Last Entry or Engine OFF"
                        ></i>
                    </th>
                    <th>Total Engine Hours</th>
                    <th>
                        All Trips&nbsp;{" "}
                        <i
                            class="fa fa-info-circle text-primary"
                            title="Trips + Virtual Trips"
                        ></i>
                    </th>
                    <th>
                        Trips/Hour &nbsp;
                        <i
                            class="fa fa-info-circle text-primary"
                            title="(All Trips / Duration outside depot) / 1 hour"
                        ></i>
                    </th>
                    {/*<th>First engine on</th>*/}
                    {/*<th>Last engine off</th>*/}
                    <th>Distance</th>
                    <th>
                        Distance/Hour &nbsp;
                        <i
                            class="fa fa-info-circle text-primary"
                            title="(Total Distance / Duration outside depot)/ 1 hour"
                        ></i>
                    </th>
                    <th>Parked Idle</th>
                    <th>Duress</th>
                    <th>Powercut</th>
                    <th>Low Battery</th>
                    <th>Temp A</th>
                    <th>Temp B</th>
                    <th>Overspeed</th>
                    <th>Harsh Accel</th>
                    <th>Harsh Brake</th>
                    <th>Harsh Corner</th>
                    <th>OH&S</th>
                    <th>GSM Loss</th>
                    <th>GPS Loss</th>
                    <th>Processed</th>
                </tr>
            </thead>
            <tbody>
                {reports.map((report, index) => {
                    return (
                        <tr className={report.allTrips == 0 ? "yellowBg" : ""}>
                            <td>{weekDayFinder(report.dateTime)}</td>
                            <td style={{ whiteSpace: "nowrap" }}>
                                <NavLink title={`View MVTL for this date`} to={`/Rpt-MVTL?assetId=${asset_id}&assetName=${report.asset}&assetDate=${moment(report.dateTime).format("YYYY-MM-DD")}`} target="_blank">{utcToDDMMYYYY(report.dateTime)}</NavLink>
                                {/* {utcToDDMMYYYY(report.dateTime)} */}
                            </td>

                            <td>{report.asset}
                            <br />
                                <ShowIButtonName
                                    ibuttonId={ibuttonId}
                                    serialno={serialno}
                                    iButtonName={iButtonName}
                                />
                            </td>
                            {/* <td>{report.trips}</td>
<td>{report.virtualTrips}</td> */}
                            <td>{dayToHour(report.duration)}</td>
                            <td>{dayToHour(report.durationOutsideDepot)}</td>
                            <td>{dayToHour(report.totalEngineHours)}</td>
                            <td>{report.allTrips}</td>
                            <td>{report.tripPerHour}</td>
                            {/*<td>{utcToReportDate(report.start)}</td>*/}
                            {/*<td>{utcToReportDate(report.end)}</td>*/}
                            <td>{rounding(report.distance)}</td>
                            <td>{report.distancePerHour}</td>
                            <td>{report.parkedIdle}</td>
                            <td>{report.duress}</td>
                            <td>{report.powercut}</td>
                            <td>{report.lowBattery}</td>
                            <td>{report.tempA}</td>
                            <td>{report.tempB}</td>
                            <td>{report.speed}</td>
                            <td>{report.harshAccel}</td>
                            <td>{report.harshBrake}</td>
                            <td>{report.harshCorner}</td>
                            <td>{report.ohs}</td>
                            <td>{report.gsmLoss}%</td>
                            <td>{report.gpsLoss}%</td>
                            <td>{report.processed}</td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
    const handleDownloadExcel = () => {
        downloadCSVFile(props.reportDetails.dayTrips, "AssetRunning_HourlySummaryPerDay", assetName, timeZone);
    };
    return (
        <ToggleBar
            caption="Hourly Summary Per Day"
            icon="fa-clock-o"
            color="#337AB7"
            content={data}
            download={handleDownloadExcel}
        />
    );
}

export default HourlySummary;
